import IconButton from '@mui/material/IconButton';
import Delete from '@mui/icons-material/Delete';
import { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useSnackbar } from '~/containers/Snackbar/SnackbarContext';
import { useDeleteCongregation } from '~/hooks/api/useDeleteCongregation';
import ConfirmationModal from '../ConfirmationModal';
import messages from './messages';

type CongregationDeleteButtonProps = {
  congregationId: number;
  handleBackButton: () => void;
};

const CongregationDeleteButton = (props: CongregationDeleteButtonProps) => {
  const intl = useIntl();
  const { showSnackbar } = useSnackbar();
  const [shouldShowConfirmationModal, setConfirmationModalVisibility] =
    useState(false);
  const deleteCongregationMutation = useDeleteCongregation({
    onSuccess() {
      showSnackbar({
        message: intl.formatMessage(messages.deleteSuccess),
      });
      // we redirect the user back to the congregation list page
      props.handleBackButton();
    },
    onError() {
      showSnackbar({
        message: intl.formatMessage(messages.deleteFailure),
      });
    },
  });
  return (
    <>
      <IconButton
        color="inherit"
        onClick={() => setConfirmationModalVisibility(true)}
        size="large"
      >
        <Delete data-testid="delete" />
      </IconButton>

      <ConfirmationModal
        open={shouldShowConfirmationModal}
        title={intl.formatMessage(messages.deleteConfirmTitle)}
        text={<FormattedMessage {...messages.deleteConfirmText} />}
        confirmLabel={<FormattedMessage {...messages.deleteConfirmDelete} />}
        cancelLabel={<FormattedMessage {...messages.deleteConfirmCancel} />}
        onCancel={() => setConfirmationModalVisibility(false)}
        onConfirm={() =>
          deleteCongregationMutation.mutate(props.congregationId)
        }
      />
    </>
  );
};

export default CongregationDeleteButton;
